import React from "react"
import Spinner from "react-spinkit"
import { Modal, Button } from "react-bootstrap"
import ProcessesStatus from "../fragments/ProcessesStatus"

export default function CheckBundleActivity({ activity, nbLoan, bundle, show, close,
  activityError, activityRunning, doAction  }) {

  const getTitle = () => {

    switch(activity) {
      case 0:
        return 'Checking loans in which this bundle is used.'
      case 1:
        return `The "${ bundle.name }" bundle is used in ${ nbLoan } loan${ nbLoan > 1 ? 's' : '' }.
        It can be marked as inactive.`
      default:
        return 'Delete this bundle will permanently remove it from the system. Are you sure you want to continue ?'
    }
  }

  const getButtonTitle = () => {
    switch(activity) {
      case 0:
        return 'Waiting'
      case 1:
        return 'Mark as inactive'
      default:
        return 'Remove'
    }
  }

  return (
    <Modal show={ show } onHide={ close }>

      <Modal.Header closeButton>
        <Modal.Title>
          Removing <strong>{ bundle.name }</strong> bundle
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{ getTitle() }</p>
        <ProcessesStatus
          error={ activityError }
          running={ activityRunning }
          runningText={ <span>Please wait .. <Spinner name="ball-beat" className="inline" /></span> }
        />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>Cancel</Button>
        <Button bsStyle="danger" onClick={() => doAction(activity) }
          disabled={ activityRunning || activityError || activity === 0 }>
          { getButtonTitle() }
        </Button>
      </Modal.Footer>

    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/Bundles/CheckBundleActivity.js